import { render } from "./CourseListPage.vue?vue&type=template&id=46233850"
import script from "./CourseListPage.vue?vue&type=script&lang=js"
export * from "./CourseListPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__